import * as t from "io-ts";

export const objectGetTypedKeys = Object.keys as <T extends object>(
  obj: T
) => Array<keyof T>;

// https://stackoverflow.com/a/65838169/5993042
function getKeysFromStringArray<T extends readonly string[]>(
  arr: T
): { [K in T[number]]: null } {
  return Object.fromEntries(arr.map(v => [v, null])) as any;
}

export function getIoTsStringsUnionFromConstStringArray<
  T extends readonly string[]
>(arr: T) {
  return t.keyof(getKeysFromStringArray(arr));
}
